import './projects-grid.scss';
import { findAll, onBlockRender, once } from '../../global/utils/acf-preview';

// Projects Grid: category filter tabs + "Load more" batching. In the "All" view
// cards reveal in batches of `step`; filtering to a category shows all of that
// category. Figma 268-4232.
function initProjectsGrid( grid: HTMLElement ): void {
	if ( ! once( grid, 'ProjectsGrid' ) ) {
		return;
	}
	const scope: ParentNode = grid.closest<HTMLElement>( '.projects-grid-block' ) ?? grid.ownerDocument;

	const items = Array.from( grid.querySelectorAll<HTMLElement>( '.projects-grid__item' ) );
	const filterBar = scope.querySelector<HTMLElement>( '[data-project-filter]' );
	const loadMore = scope.querySelector<HTMLButtonElement>( '[data-load-more]' );
	const step = loadMore ? parseInt( loadMore.dataset.step || '6', 10 ) : items.length;

	let activeFilter = 'all';
	let visible = step;

	const render = (): void => {
		let matchCount = 0;
		items.forEach( ( item ) => {
			const matches = activeFilter === 'all' || item.dataset.category === activeFilter;
			// In the "All" view honour the batch limit; a category shows all matches.
			const show = matches && ( activeFilter !== 'all' || matchCount < visible );
			if ( matches ) {
				matchCount += 1;
			}
			item.classList.toggle( 'is-hidden', ! show );
		} );
		if ( loadMore ) {
			loadMore.style.display = activeFilter === 'all' && matchCount > visible ? '' : 'none';
		}
	};

	if ( filterBar ) {
		const tabs = Array.from( filterBar.querySelectorAll<HTMLElement>( '.projects-filter__tab' ) );
		tabs.forEach( ( tab ) => {
			tab.addEventListener( 'click', () => {
				tabs.forEach( ( t ) => t.classList.remove( 'is-active' ) );
				tab.classList.add( 'is-active' );
				activeFilter = tab.dataset.filter || 'all';
				visible = step;
				render();
			} );
		} );
	}

	if ( loadMore ) {
		loadMore.addEventListener( 'click', () => {
			visible += step;
			render();
		} );
	}

	render();
}

onBlockRender( 'projects-grid', ( root ) => {
	findAll<HTMLElement>( root, '[data-project-grid]' ).forEach( initProjectsGrid );
} );
